// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 939) return "static/chunks/939-c726f0c3133d91aa.js";
	if (chunkId === 612) return "static/chunks/612-3a98f86ecf8238e8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"155":"6d73c909877c3eab","543":"996b4737321d7dce","544":"22ed08f2ad763bb3","627":"0b5dd6db08852efa","635":"953097881150483e","968":"f4c212b483d12d27"}[chunkId] + ".js";
};